var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h-header'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),(_vm.loading)?_c('div',{staticClass:"loading-overlay"},[_c('img',{attrs:{"src":require('@/static/img/loading.gif'),"alt":"Loading"}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }